/* @flow */
import React from 'react';
import { FormattedMessage } from 'react-intl';

// Component
import { PriceLabel } from './PriceLabel';
import { textPercentageOff } from '../helpers/priceTypeConstants';

// Styles
import styles from './styles.scss';

type SaleProps = {|
    currency: string,
    percentageOff: ?number,
    price: number,
    quantityDisplay?: string,
    showPriceVariability: boolean,
|};

export function Sale({
    percentageOff,
    price,
    quantityDisplay,
    currency,
    showPriceVariability,
}: SaleProps) {
    const label = (
        <FormattedMessage id="dc.searchProductTile.salePrice" defaultMessage="Sale Price" />
    );

    return (
        <React.Fragment>
            <PriceLabel
                price={price}
                label={percentageOff ? label : ''}
                quantityDisplay={quantityDisplay}
                currency={currency}
                showPriceVariability={showPriceVariability}
            />
            {percentageOff ? (
                <div className={`${styles.percentageOff} ${styles.sale}`} data-tn="discount-amount">
                    {textPercentageOff(percentageOff)}
                </div>
            ) : null}
        </React.Fragment>
    );
}

Sale.defaultProps = {
    percentageOff: null,
    showPriceVariability: false,
};
